module.exports = __webpack_public_path__ + "static/media/download2.5bbb6e54.png";